import React from "react";
import ContactForm from "../sections/contact/ContactForm";
import ContactInfo from "../sections/contact/ContactInfo";

const Contact: React.FC = () => {
  return (
    <div className="w-full">
      <ContactForm />
      <ContactInfo />
    </div>
  );
};

export default Contact;
